import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Navigate, useSearchParams } from 'react-router';

import Logger from 'browser-logging/src/browser/Logger';

import useAuth from 'portal/src/auth/useAuth';
import usePageTitle from 'portal/src/navigation/usePageTitle';

export const SSO = () => {
  usePageTitle();

  const [params] = useSearchParams();
  const jwt = params.get('jwt');
  const dest = (params.get('dest') ?? '/').replace(/^([^\/].*)$/, '/$1');

  const { ssoAuthLogin, isAuthenticated } = useAuth();
  const [error, setError] = useState(!jwt);

  useEffect(() => {
    const fetchLogin = async (): Promise<void> => {
      try {
        const response = await ssoAuthLogin(jwt);
        !response && setError(!response);
      } catch (err) {
        Logger.captureError(err as Error);
        setError(true);
      }
    };

    fetchLogin();
  }, [jwt, ssoAuthLogin]);

  if (isAuthenticated()) {
    return <Navigate to={dest} replace />;
  }

  return (
    <Stack spacing={2} sx={{ margin: 20 }}>
      {!error && (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      )}
      <Typography variant="h6" sx={{ textAlign: 'center' }}>
        {error
          ? 'We do not recognize that user.'
          : 'Wait a minute, we are verifying the credentials.'}
      </Typography>
    </Stack>
  );
};
